<template>
    <section class="padding-vertical-content mb-3 mb-lg-4">
        <div>
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                <div class="mb-5">
                    <div>
                        <label class="mb-4 h5 text-uppercase">
                            Datos del responsable 1
                        </label>

                        <div class="row">
                            <div class="col-md-4 col-12">
                                <FormInput style="width: 96%; margin: auto" label="Nombre del responsable" type="text" name="nombre responsable" id="nombre_responsable" rules="required" v-model="base_data.nombre_responsable" :disabled="!paso_activo" />
                            </div>
                            <div class="col-md-4 col-12 mt-md-0 mt-4">
                                <FormInput style="width: 96%; margin: auto" label="Apellidos del responsable" type="text" name="apellidos responsable" id="apellidos_responsable" rules="required" v-model="base_data.apellidos_responsable" :disabled="!paso_activo" />
                            </div>
                            <div class="col-md-4 col-12">
                                <ValidationProvider name="tipo de documento responsable 1" rules="required" v-slot="{ errors }">
                                    <div class="form-group customInputCss" style="width: 96%; margin: auto">
                                        <label>{{ $t('formularios.tipo_identificacion') }}</label>
                                        <multiselect
                                            v-model="tipoDocumentoResponsable1"
                                            label="label"
                                            track-by="type"
                                            class="custom-multiselect mt-4"
                                            :class="(errors[0] ? 'is-invalid' : '')"
                                            id="tipo-documento-resp1"
                                            placeholder="Seleccione tipo de documento"
                                            :options="tiposDocumento"
                                            @input="onSeleccionTipoDocumentoResp1"
                                            :disabled="!paso_activo"
                                        />
                                        <span v-if="errors[0]" class="invalid-feedback text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;">
                                            {{ errors[0] }}
                                        </span>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-md-4 col-12">
                                <div class="form-group customDni" style="width: 96%; margin: auto" >
                                    <label>{{ texto_documentacion_resp1 }} *</label>
                                    <ValidationProvider
                                        :name="texto_documentacion_resp1"
                                        :rules="{ required: true, identificacion: { tipo: tipoDocumentoResponsable1?.type } }"
                                        v-slot="{ errors }"
                                    >
                                        <input
                                            v-model="base_data.dni_responsable"
                                            id="dni_responsable"
                                            type="text"
                                            :disabled="!paso_activo || !tipoDocumentoResponsable1"
                                            :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                            :placeholder="texto_documentacion_resp1"
                                        />
                                        <span
                                            v-if="errors[0]"
                                            class="invalid-feedback text-xs error-message"
                                            style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
                                        >
                                            <b>{{ errors[0] }}</b>
                                        </span>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-md-4 col-12 mt-md-0 mt-4">
                                <div class="form-group" style="width: 96%; margin: auto">
                                    <label>Teléfono *</label>
                                    <PhoneInput
                                        name="telefono_responsable"
                                        id="telefono_responsable"
                                        data-cy="telefono_responsable"
                                        :phone="base_data.telefono_responsable ?? null"
                                        :desactivar="!paso_activo"
                                        :required="true"
                                        :error_telefono="error_telefono_resp1"
                                        @setNumber="(number) => base_data.telefono_responsable = number"
                                        @validNumber="(valid) => telefono_valido_resp1 = valid"
                                        @onTyping="(phone) => {
                                            if (phone && phone.length > 0) {
                                                error_telefono_resp1 = 0;
                                            }
                                        }"
                                    />
                                    <span
                                        v-if="error_telefono_resp1"
                                        class="invalid-feedback text-xs error-message mt-3"
                                        style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
                                    >
                                        <b>El teléfono es requerido y debe ser válido</b>
                                    </span>
                                </div>
                            </div>

                            <div class="col-md-4 col-12 customInputCss">
                                <FormInput style="width: 96%; margin: auto" label="Email del responsable" type="email" name="email responsable" id="email_responsable" rules="required" v-model="base_data.email_responsable" :disabled="!paso_activo" />
                            </div>
                        </div>

                        <div class="mt-5">
                            <label class="mb-4 h5 text-uppercase">
                                Datos del responsable 2
                            </label>
                        </div>

                        <div class="row">
                            <div class="col-md-4 col-12">
                                <FormInput style="width: 96%; margin: auto" label="Nombre del responsable 2" type="text" name="nombre del responsable" id="nombre_responsable_2" :rules="tieneAlgunDatoResponsable2 ? 'required' : ''" v-model="base_data.nombre_responsable_2" :disabled="!paso_activo" />
                            </div>
                            <div class="col-md-4 col-12 mt-md-0 mt-4">
                                <FormInput style="width: 96%; margin: auto" label="Apellidos del responsable 2" type="text" name="apellidos del responsable" id="apellidos_responsable_2" :rules="tieneAlgunDatoResponsable2 ? 'required' : ''" v-model="base_data.apellidos_responsable_2" :disabled="!paso_activo" />
                            </div>
                            <div class="col-md-4 col-12 customInputCss">
                                <ValidationProvider name="tipo de documento responsable 2" :rules="tieneAlgunDatoResponsable2 ? 'required' : ''" v-slot="{ errors }">
                                    <div class="form-group" style="width: 96%; margin: auto">
                                        <label>{{ $t('formularios.tipo_identificacion') }}</label>
                                        <multiselect
                                            v-model="tipoDocumentoResponsable2"
                                            label="label"
                                            track-by="type"
                                            class="custom-multiselect mt-4"
                                            :class="(errors[0] ? 'is-invalid' : '')"
                                            id="tipo-documento-resp2"
                                            placeholder="Seleccione tipo de documento"
                                            :options="tiposDocumento"
                                            @input="onSeleccionTipoDocumentoResp2"
                                            :disabled="!paso_activo"
                                        />
                                        <span v-if="errors[0]" class="invalid-feedback text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;">
                                            {{ errors[0] }}
                                        </span>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-md-4 col-12">
                                <div class="form-group customDni" style="width: 96%; margin: auto">
                                    <label>{{ texto_documentacion_resp2 }} {{ tieneAlgunDatoResponsable2 ? '*' : '' }}</label>
                                    <ValidationProvider
                                        :name="texto_documentacion_resp2"
                                        :rules="tieneAlgunDatoResponsable2 ? { required: true, identificacion: { tipo: tipoDocumentoResponsable2?.type } } : {}"
                                        v-slot="{ errors }"
                                    >
                                        <input
                                            v-model="base_data.dni_responsable_2"
                                            type="text"
                                            :disabled="!paso_activo || !tipoDocumentoResponsable2"
                                            :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                            :placeholder="texto_documentacion_resp2"
                                        />
                                        <span
                                            v-if="errors[0]"
                                            class="invalid-feedback text-xs error-message"
                                            style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
                                        >
                                            <b>{{ errors[0] }}</b>
                                        </span>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-md-4 col-12 mt-md-0 mt-4">
                                <div class="form-group" style="width: 96%; margin: auto">
                                    <label>Teléfono del responsable 2 {{ tieneAlgunDatoResponsable2 ? '*' : '' }}</label>
                                    <PhoneInput
                                        name="telefono_responsable_2"
                                        data-cy="telefono_responsable_2"
                                        :phone="base_data.telefono_responsable_2 ?? null"
                                        :desactivar="!paso_activo"
                                        :required="tieneAlgunDatoResponsable2"
                                        :error_telefono="error_telefono_resp2"
                                        @setNumber="(number) => base_data.telefono_responsable_2 = number"
                                        @validNumber="(valid) => telefono_valido_resp2 = valid"
                                        @onTyping="(phone) => {
                                            if (phone && phone.length > 0) {
                                                error_telefono_resp1 = 0;
                                            }
                                        }"
                                    />
                                    <span
                                        v-if="error_telefono_resp2"
                                        class="invalid-feedback text-xs error-message mt-3"
                                        style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
                                    >
                                        <b>El teléfono es requerido y debe ser válido</b>
                                    </span>
                                </div>
                            </div>

                            <div class="col-md-4 col-12 customInputCss">
                                <FormInput style="width: 96%; margin: auto" label="Email del responsable 2" type="email" name="email_responsable_2" id="email_responsable_2" :rules="tieneAlgunDatoResponsable2 ? 'required' : ''" v-model="base_data.email_responsable_2" :disabled="!paso_activo" />
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="col-12">
                                <FormInput style="width: 98%; margin: auto" label="Observaciones" type="text" name="observaciones" id="observaciones" rules="" v-model="base_data.observaciones" :disabled="!paso_activo" />
                            </div>
                        </div>

                        <div class="col-12 text-right mt-4">
                            <button type="button" @click="volver" name="button" :class="!esMovil ? 'button effect-button large-button mr-2' : 'button effect-button mr-2'" id="volver-paso-1" :disabled="!paso_activo">
                                <span>{{ $t('formularios.atras') }}</span>
                            </button>
                            <button type="submit" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" id="terminar-paso-2" :disabled="!paso_activo">
                                <span>{{ $t('formularios.continuar') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </ValidationObserver>
        </div>
    </section>
</template>


<script>
    import PhoneInput from '@/components/common/PhoneInput';

    export default {
        props: {
            base: {
                type: Object,
                required: true
            },
            esMovil: {
                type: Boolean,
                default: false
            },
            paso_activo: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                base_data : { ...this.base },
                fields_responsable_1: {},
                fields_responsable_2: {},
                lista_id: this.$route.params.lista_id,
                error_telefono_resp1: 0,
                error_telefono_resp2: 0,
                telefono_valido_resp1: false,
                tipoDocumentoResponsable1: null,
                tipoDocumentoResponsable2: null,
                telefono_valido_resp2: false,
                texto_documentacion_resp1: 'Seleccione el tipo de documento',
                texto_documentacion_resp2: 'Seleccione el tipo de documento',
                tiposDocumento: [
                    { type: 'DNI', label: 'DNI' },
                    { type: 'NIE', label: 'NIE' },
                    { type: 'NIF', label: 'NIF' },
                    { type: 'PASSPORT', label: 'PASAPORTE' }
                ]
            };
        },
        created() {
            if(window.location.href.indexOf("renovar") > -1) {

                if (!this.base_data.nombre_responsable && this.base_data.nombre_responsable_1){
                    this.base_data.nombre_responsable = this.base_data.nombre_responsable_1;
                    this.base_data.apellidos_responsable = this.base_data.apellidos_responsable_1;
                    this.base_data.dni_responsable = this.base_data.dni_responsable_1;
                    this.base_data.telefono_responsable = this.base_data.telefono_responsable_1;
                    this.base_data.email_responsable = this.base_data.email_responsable_1;
                }
            }

            this.tipoDocumentoResponsable1 = this.tiposDocumento.find(tipo => tipo.type === 'DNI');
            this.setTextoDocumentacionResp1();
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            fields() {
                return this.$store.getters.getListaAbonados.basesFields.filter(field => field.representante === true);
            },
            tieneAlgunDatoResponsable2() {
                return !!(
                    (this.base_data.nombre_responsable_2 && this.base_data.nombre_responsable_2.trim()) ||
                    (this.base_data.apellidos_responsable_2 && this.base_data.apellidos_responsable_2.trim()) ||
                    (this.base_data.dni_responsable_2 && this.base_data.dni_responsable_2.trim()) ||
                    (this.base_data.telefono_responsable_2 && this.base_data.telefono_responsable_2.trim()) ||
                    (this.base_data.email_responsable_2 && this.base_data.email_responsable_2.trim()) ||
                    Object.values(this.fields_responsable_2).some(val => val && val.toString().trim() !== '')
                );
            },
        },
        methods: {
            terminar() {
                const responsable_1 = {
                    nombre: this.base_data.nombre_responsable,
                    apellidos: this.base_data.apellidos_responsable,
                    telefono: this.base_data.telefono_responsable,
                    dni: this.base_data.dni_responsable,
                    email: this.base_data.email_responsable,
                    fields: Object.keys(this.fields_responsable_1).map(key => ({
                        name: key,
                        value: this.fields_responsable_1[key]
                    }))
                };

                const responsable_2 = {
                    nombre: this.base_data.nombre_responsable_2,
                    apellidos: this.base_data.apellidos_responsable_2,
                    dni: this.base_data.dni_responsable_2,
                    telefono: this.base_data.telefono_responsable_2,
                    email: this.base_data.email_responsable_2,
                    fields: Object.keys(this.fields_responsable_2).map(key => ({
                        name: key,
                        value: this.fields_responsable_2[key]
                    }))
                };


                let params = {
                    responsable_1,
                    lista_id: this.lista_id,
                    session_id: this.base.categoria_base.session_id,
                    filters: {
                        tid: this.configuracion.hash_teatro
                    }
                }

                if (this.tieneAlgunDatoResponsable2) {
                    params.responsable_2 = responsable_2;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.bases.guardar-datos-responsables'), params).then(res => {
                    this.base_data.categoria_base.session_id = res.data.session_id;
                });

                this.base_data.fields_responsable_1 = responsable_1.fields;
                if(this.tieneAlgunDatoResponsable2)
                {
                    this.base_data.fields_responsable_2 = responsable_2.fields;
                }
                this.$emit("guardarBase", this.base_data);
                this.$emit('terminado');
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();

                const telefono_resp1_valido = this.telefono_valido_resp1 && this.base_data.telefono_responsable;
                const telefono_resp2_valido = !this.tieneAlgunDatoResponsable2 || (this.telefono_valido_resp2 && this.base_data.telefono_responsable_2);

                if (isValid && telefono_resp1_valido && telefono_resp2_valido) {
                    this.error_telefono_resp1 = 0;
                    this.error_telefono_resp2 = 0;
                    this.terminar();
                } else {
                    if (!telefono_resp1_valido) {
                        this.error_telefono_resp1 = 1;
                    }
                    if (!telefono_resp2_valido && this.tieneAlgunDatoResponsable2) {
                        this.error_telefono_resp2 = 1;
                    }
                }
            },
            onSeleccionTipoDocumentoResp1(option) {
                this.tipoDocumentoResponsable1 = option;
                this.setTextoDocumentacionResp1();
                this.base_data.dni_responsable = '';
            },
            onSeleccionTipoDocumentoResp2(option) {
                this.tipoDocumentoResponsable2 = option;
                this.setTextoDocumentacionResp2();
                this.base_data.dni_responsable_2 = '';
            },
            setTextoDocumentacionResp1() {
                switch (this.tipoDocumentoResponsable1?.type) {
                    case 'DNI':
                        this.texto_documentacion_resp1 = 'DNI';
                        break;
                    case 'NIE':
                        this.texto_documentacion_resp1 = 'NIE';
                        break;
                    case 'NIF':
                        this.texto_documentacion_resp1 = 'NIF';
                        break;
                    case 'PASSPORT':
                        this.texto_documentacion_resp1 = 'Pasaporte';
                        break;
                    default:
                        this.texto_documentacion_resp1 = 'Seleccione el tipo de documento';
                        break;
                }
            },
            setTextoDocumentacionResp2() {
                switch (this.tipoDocumentoResponsable2?.type) {
                    case 'DNI':
                        this.texto_documentacion_resp2 = 'DNI';
                        break;
                    case 'NIE':
                        this.texto_documentacion_resp2 = 'NIE';
                        break;
                    case 'NIF':
                        this.texto_documentacion_resp2 = 'NIF';
                        break;
                    case 'PASSPORT':
                        this.texto_documentacion_resp2 = 'Pasaporte';
                        break;
                    default:
                        this.texto_documentacion_resp2 = 'Seleccione el tipo de documento';
                        break;
                }
            },
            volver() {
                this.$emit("guardarBase", this.base_data);
                this.$emit('volver');
            },
            checkAndInitResponsable2(newVal) {
                if (newVal && newVal.trim() && !this.tipoDocumentoResponsable2) {
                    this.tipoDocumentoResponsable2 = this.tiposDocumento.find(tipo => tipo.type === 'DNI');
                    this.setTextoDocumentacionResp2();
                }
            },
        },
        watch: {
            'base_data.nombre_responsable_2': 'checkAndInitResponsable2',
            'base_data.apellidos_responsable_2': 'checkAndInitResponsable2',
            'base_data.telefono_responsable_2': 'checkAndInitResponsable2',
            'base_data.email_responsable_2': 'checkAndInitResponsable2',
            'base_data.observaciones': 'checkAndInitResponsable2',

            tieneAlgunDatoResponsable2(newVal) {
                if (!newVal && this.tipoDocumentoResponsable2) {

                    this.tipoDocumentoResponsable2 = null;
                    this.texto_documentacion_resp2 = 'Seleccione el tipo de documento';
                    this.base_data.dni_responsable_2 = '';
                }
            }
        },
        components: { PhoneInput }
    };
</script>
